import { IconTrash } from "@tabler/icons-react";
import ConfirmDeleteModal from "@components/modals/ConfirmDeleteModal";

export function StartPointDeleteButton({ order, onClick }) {
  return (
    <button
      type="button"
      className="app-icon-btn app-icon-btn--delete start-point-tool-delete"
      aria-label={`Delete  driving tour points ${order}`}
      title={`Delete  driving tour points ${order}`}
      onClick={onClick}
    >
      <IconTrash size={14} />
    </button>
  );
}

export function StartPointDeleteModal({
  isOpen,
  deletingStartPoint,
  onClose,
  onConfirm,
}) {
  return (
    <ConfirmDeleteModal
      isOpen={Boolean(isOpen)}
      onClose={onClose}
      onConfirm={onConfirm}
      submitting={deletingStartPoint}
      title="Delete driving tour points"
      description="Are you sure you want to delete this driving tour points?"
    />
  );
}
